export default {
  state: {
    login_bol: false    // 是否已经登录
  },
  mutations: {
    set_login_bol (state, val) {
      state.login_bol = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/login-store.js